import { Descriptions } from "antd";
import React from "react";
import styles from "../styles.module.less";

const { card, content, label } = styles;

interface IProps {
  des: (
    | {
        label: string;
        content: string;
      }
    | {
        label: string;
        content: string[];
      }
  )[];
}

const JournalCard: React.FC<IProps> = ({ des }) => {
  return (
    <div className={card}>
      <Descriptions>
        {des.map((e) => (
          <Descriptions.Item
            label={<span className={label}>{e.label}</span>}
            key={e.label}
          >
            <span className={content}>
              {Array.isArray(e.content)
                ? e.content.map((m, k) => (
                    <div key={m}>
                      <strong>{k + 1}.</strong> {m}
                    </div>
                  ))
                : e.content}
            </span>
          </Descriptions.Item>
        ))}
      </Descriptions>
    </div>
  );
};

export default JournalCard;
